import { render, staticRenderFns } from "./TabelleCustomList.vue?vue&type=template&id=21e88f49&scoped=true&"
import script from "./TabelleCustomList.vue?vue&type=script&lang=js&"
export * from "./TabelleCustomList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e88f49",
  null
  
)

export default component.exports